module.exports = __webpack_public_path__ + "static/media/3.548fc9ab.jpg";